import { Stethoscope, Clock, Award, Users } from "lucide-react";

const iconMap = [Stethoscope, Clock, Award, Users];

export const WhyUs = ({ t }) => {
  return (
    <section id="porquenosso" data-testid="why-us-section" className="section-dark py-24 md:py-32 relative overflow-hidden">
      <div className="absolute top-1/2 left-1/4 w-[800px] h-[800px] bg-[radial-gradient(circle_at_center,rgba(197,160,89,0.05)_0%,transparent_60%)] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          <div>
            <span className="text-sm tracking-[0.3em] uppercase text-[#C5A059] block mb-4">{t.whyUs.badge}</span>
            <h2 data-testid="why-us-title" className="text-4xl md:text-5xl font-medium tracking-tight text-[#E5E5E5] mb-6 line-accent" style={{ fontFamily: "'Playfair Display', serif" }}>
              {t.whyUs.title} <span className="text-gold-gradient">{t.whyUs.highlight}</span>
            </h2>
            <p className="text-[#A3A3A3] text-lg leading-relaxed mb-8">
              {t.whyUs.desc}
            </p>

            <div className="space-y-4">
              <p className="text-sm tracking-widest uppercase text-[#A3A3A3]">{t.whyUs.specLabel}</p>
              <div className="flex flex-wrap gap-3">
                <span className="px-4 py-2 text-sm text-[#E5E5E5] border border-white/10 hover:border-[#C5A059]/30 transition-colors">{t.whyUs.specs[0]}</span>
                <span className="px-4 py-2 text-sm text-[#E5E5E5] border border-white/10 hover:border-[#C5A059]/30 transition-colors">{t.whyUs.specs[1]}</span>
                <span className="px-4 py-2 text-sm text-[#E5E5E5] border border-white/10 hover:border-[#C5A059]/30 transition-colors">{t.whyUs.specs[2]}</span>
                <span className="px-4 py-2 text-sm text-[#E5E5E5] border border-white/10 hover:border-[#C5A059]/30 transition-colors">{t.whyUs.specs[3]}</span>
                <span className="px-4 py-2 text-sm text-[#E5E5E5] border border-white/10 hover:border-[#C5A059]/30 transition-colors">{t.whyUs.specs[4]}</span>
                <span className="px-4 py-2 text-sm text-[#E5E5E5] border border-white/10 hover:border-[#C5A059]/30 transition-colors">{t.whyUs.specs[5]}</span>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 md:gap-6">
            <div className="glass-card p-6 md:p-8 group hover:border-[#C5A059]/30 transition-all duration-300">
              <div className="w-12 h-12 border border-[#C5A059]/30 flex items-center justify-center mb-6 group-hover:bg-[#C5A059]/10 transition-colors duration-300">
                <Stethoscope className="w-5 h-5 text-[#C5A059]" />
              </div>
              <div className="mb-4">
                <p className="text-3xl md:text-4xl font-medium text-[#C5A059]" style={{ fontFamily: "'Playfair Display', serif" }}>{t.whyUs.reasons[0].stat}</p>
                <p className="text-xs tracking-widest uppercase text-[#A3A3A3] mt-1">{t.whyUs.reasons[0].label}</p>
              </div>
              <h3 className="text-lg font-medium text-[#E5E5E5] mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>{t.whyUs.reasons[0].title}</h3>
              <p className="text-[#A3A3A3] text-sm leading-relaxed">{t.whyUs.reasons[0].desc}</p>
            </div>
            <div className="glass-card p-6 md:p-8 group hover:border-[#C5A059]/30 transition-all duration-300">
              <div className="w-12 h-12 border border-[#C5A059]/30 flex items-center justify-center mb-6 group-hover:bg-[#C5A059]/10 transition-colors duration-300">
                <Clock className="w-5 h-5 text-[#C5A059]" />
              </div>
              <div className="mb-4">
                <p className="text-3xl md:text-4xl font-medium text-[#C5A059]" style={{ fontFamily: "'Playfair Display', serif" }}>{t.whyUs.reasons[1].stat}</p>
                <p className="text-xs tracking-widest uppercase text-[#A3A3A3] mt-1">{t.whyUs.reasons[1].label}</p>
              </div>
              <h3 className="text-lg font-medium text-[#E5E5E5] mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>{t.whyUs.reasons[1].title}</h3>
              <p className="text-[#A3A3A3] text-sm leading-relaxed">{t.whyUs.reasons[1].desc}</p>
            </div>
            <div className="glass-card p-6 md:p-8 group hover:border-[#C5A059]/30 transition-all duration-300">
              <div className="w-12 h-12 border border-[#C5A059]/30 flex items-center justify-center mb-6 group-hover:bg-[#C5A059]/10 transition-colors duration-300">
                <Award className="w-5 h-5 text-[#C5A059]" />
              </div>
              <div className="mb-4">
                <p className="text-3xl md:text-4xl font-medium text-[#C5A059]" style={{ fontFamily: "'Playfair Display', serif" }}>{t.whyUs.reasons[2].stat}</p>
                <p className="text-xs tracking-widest uppercase text-[#A3A3A3] mt-1">{t.whyUs.reasons[2].label}</p>
              </div>
              <h3 className="text-lg font-medium text-[#E5E5E5] mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>{t.whyUs.reasons[2].title}</h3>
              <p className="text-[#A3A3A3] text-sm leading-relaxed">{t.whyUs.reasons[2].desc}</p>
            </div>
            <div className="glass-card p-6 md:p-8 group hover:border-[#C5A059]/30 transition-all duration-300">
              <div className="w-12 h-12 border border-[#C5A059]/30 flex items-center justify-center mb-6 group-hover:bg-[#C5A059]/10 transition-colors duration-300">
                <Users className="w-5 h-5 text-[#C5A059]" />
              </div>
              <div className="mb-4">
                <p className="text-3xl md:text-4xl font-medium text-[#C5A059]" style={{ fontFamily: "'Playfair Display', serif" }}>{t.whyUs.reasons[3].stat}</p>
                <p className="text-xs tracking-widest uppercase text-[#A3A3A3] mt-1">{t.whyUs.reasons[3].label}</p>
              </div>
              <h3 className="text-lg font-medium text-[#E5E5E5] mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>{t.whyUs.reasons[3].title}</h3>
              <p className="text-[#A3A3A3] text-sm leading-relaxed">{t.whyUs.reasons[3].desc}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
